const userInfoTypes = {

    SET_STATE_ACTION_TYPE: 'SET_STATE_ACTION_TYPE',

    START_LOGIN: 'START_LOGIN',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',

    START_REGISTER: ' START_REGISTER',
    REGISTE_SUCCESS: ' REGISTE_SUCCESS',
    REGISTE_FAILURE: ' REGISTE_FAILUR',

    START_UPDATE_USER: 'START_UPDATE_USER',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_FAILUR: 'UPDATE_USER_FAILUR',

    SET_IS_OPU_SUCCESS: 'SET_IS_OPU_SUCCESS',
    SET_IS_OPU_FAILURE: 'SET_IS_OPU_FAILURE',


    START_FORGOTE_PASSWORD: 'START_FORGOTE_PASSWORD',
    FORGOTE_PASSWORD_SUCCESS: 'FORGOTE_PASSWORD_SUCCESS',
    FORGOTE_PASSWORD_FAILURE: 'FORGOTE_PASSWORD_FAILURE',

    START_RESET_PASSWORD: 'START_RESET_PASSWORD',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

    START_GET_USER_DETAILS: 'START_GET_USER_DETAILS',
    GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',
    GET_USER_DETAILS_FAILURE: 'GET_USER_DETAILS_FAILURE',

    // Self-service account deletion (spec 000001). Gated OFF by default; the backend cannot yet return
    // Succeeded, so DELETE_ACCOUNT_SUCCESS/logout are prepared but never fire under the current gates.
    START_DELETE_ACCOUNT: 'START_DELETE_ACCOUNT',
    DELETE_ACCOUNT_SUCCESS: 'DELETE_ACCOUNT_SUCCESS',
    DELETE_ACCOUNT_FAILURE: 'DELETE_ACCOUNT_FAILURE',

    LOGOUT: 'LOGOUT',

    AUTO_LOGIN: 'AUTO_LOGIN',
    RESET_STATE_INFO: 'RESET_STATE_INFO'
};

export default userInfoTypes;